import {useEffect, useRef, useState} from 'react';
import {useNavigate} from 'react-router';
import {useAuth} from '../hooks/AuthContext';

/** OIDC redirect target: exchanges the authorization code (PKCE) and returns to the app. */
export default function AuthCallback() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    auth
      .completeLogin()
      .then((returnTo) => navigate(returnTo || '/', {replace: true}))
      .catch((err) => setError(err.message || 'Sign-in failed'));
  }, [auth, navigate]);

  return (
    <main className="auth-page" aria-live="polite">
      {error ? (
        <div role="alert">
          <h1>Sign-in failed</h1>
          <p>{error}</p>
          <button type="button" className="btn btn-primary" onClick={() => auth.login('/')}>
            Try again
          </button>
        </div>
      ) : (
        <p>Signing you in…</p>
      )}
    </main>
  );
}
